var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import { TimeOffEntryStatus } from '@amzn/atoz-shiftapp-types';
import { formatDuration, getTimeIntervalStr } from '@amzn/atoz-shiftapp-utilities';
import { ScheduledShiftStatusType, useWorkedShiftStatus } from '../../../../hooks';
import { BannerList, BannerTypes } from '../BannerList';
export var ShiftDetailsModalWorkedBannersFeature = function (_a) {
    var scheduleShift = _a.scheduleShift, timeoffEntries = _a.timeoffEntries;
    var t = useTranslation().t;
    var shiftStatusMap = useWorkedShiftStatus({
        scheduleShift: scheduleShift,
        timeoffEntries: timeoffEntries
    });
    var statusToRender = [];
    if (shiftStatusMap[ScheduledShiftStatusType.hasTimeOff]) {
        timeoffEntries.map(function (timeOffEntry, i) {
            var intervalStr = getTimeIntervalStr(DateTime.fromISO(timeOffEntry.startAt), DateTime.fromISO(timeOffEntry.endAt));
            var duration = DateTime.fromISO(timeOffEntry.endAt).diff(DateTime.fromISO(timeOffEntry.startAt), ['hours', 'minutes', 'seconds']);
            var durationStr = formatDuration(duration);
            var isPending = timeOffEntry.status === TimeOffEntryStatus.Pending;
            statusToRender.push({
                testId: "ShiftDetailsModalWorkedBanners_hasTimeOff_".concat(isPending ? 'pending' : 'approved', "_").concat(i),
                listKey: "".concat(ScheduledShiftStatusType.hasTimeOff, "_").concat(i),
                type: isPending
                    ? BannerTypes.Informational
                    : BannerTypes.Success,
                text: t(isPending
                    ? 'shift_management_features_ShiftCard_timeOffPending'
                    : 'shift_management_features_ShiftCard_timeOffApproved', { intervalStr: intervalStr, durationStr: durationStr })
            });
        });
    }
    return React.createElement(BannerList, { bannerList: statusToRender });
};
ShiftDetailsModalWorkedBannersFeature.fragments = {
    scheduleShift: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment ShiftDetailsModalWorkedBanners_ScheduleShift on ScheduleShift {\n            ...UseWorkedShiftStatus_ScheduleShift\n        }\n\n        ", "\n    "], ["\n        fragment ShiftDetailsModalWorkedBanners_ScheduleShift on ScheduleShift {\n            ...UseWorkedShiftStatus_ScheduleShift\n        }\n\n        ", "\n    "])), useWorkedShiftStatus.fragments.scheduleShift)
};
var templateObject_1;
